export default function TestCardSkeleton() {
  return (
    <div className="shadow-gray-sm relative animate-pulse rounded-2xl border border-gray-200 bg-white px-4 pb-4">
      <div className="absolute right-4 top-4 h-6 w-5 rounded bg-gray-200" />
      <div className="mt-9.5 flex flex-col items-center justify-center space-y-4">
        <div className="flex items-center justify-center">
          <div className="inline-flex h-16 w-16 rounded-lg bg-gray-200" />
        </div>
        <div className="h-5 w-20 rounded bg-gray-200" />
        <div className="flex items-center gap-1.5">
          <div className="h-5 w-10 rounded-full bg-gray-200" />
          <div className="h-5 w-14 rounded-full bg-gray-200" />
          <div className="h-5 w-10 rounded-full bg-gray-200" />
        </div>
      </div>
      <div className="mt-4 h-9 w-full rounded-xl bg-gray-200" />
    </div>
  );
}
